import { RpcApiService } from '@/api/client/services/SSEApiService';

import { ITokenMeta, IUserCredentials, OAuthConfig } from '../../types';
import OAuthTokenService from './OAuthTokenService';

export default abstract class OAuthSessionService extends OAuthTokenService {
  tokenMeta: ITokenMeta;
  userName: string;
  userPass: string;

  _rpcApiService = new RpcApiService();

  /*  */
  constructor(
    oAuthConfig: OAuthConfig,
    { userName, userPass }: IUserCredentials
  ) {
    super(oAuthConfig);

    this.tokenMeta = {} as ITokenMeta;
    this.userName = userName;
    this.userPass = userPass;
  }

  /*  */
  // async authenticate() {
  //   const tokenMetaString = await this.formSendAndProcess(this.endpointToken, [
  //     ['grant_type', 'password'],
  //     ['password', this.userPass],
  //     ['username', this.userName]
  //   ]);
  //   this.tokenMetaSet(tokenMetaString);
  // }

  async authenticate() {
    if (this.tokenMeta && this.tokenMeta.access_token) {
      const parsed = this.tokenParse(this.tokenMeta.access_token);
      if (!this.tokenCheckIsExpired(parsed)) {
        return this.tokenMeta;
      }

      await this.tokenRefreshAndUpdate();
      if (this.tokenMeta && this.tokenMeta.access_token) {
        return this.tokenMeta;
      }
    }

    const res = await this._rpcApiService.storageAuth();
    const response = res?.response;

    if (!response) {
      console.log('error', res);
      return null;
    }
    const tokenString =
      typeof response === 'string' ? response : JSON.stringify(response);
    this.tokenMetaSet(tokenString);
    return this.tokenMeta;
  }

  /*  */
  tokenMetaCheckIsExpired() {
    const accessToken = this.tokenMeta.access_token;
    // console.log('tokenMetaCheckIsExpired');
    // console.log(accessToken);
    // console.log(this.tokenMeta);
    // console.log('===');
    if (!accessToken) return;
    const tokenParsed = this.tokenParse(accessToken);
    if (this.tokenCheckIsExpired(tokenParsed)) {
      this.tokenRefreshAndUpdate();
    }
  }

  /*  */
  tokenMetaSet(tokenMetaString: string | null) {
    this.tokenMeta = this.tokenMetaStringToObject(tokenMetaString);
  }

  /*  */
  tokenMetaStringToObject(token: string | null) {
    if (!token) return null;

    try {
      return JSON.parse(token) || null;
    } catch (err) {
      console.log(
        'tokenMetaStringToObject |',
        err instanceof Error ? err.message : err
      );
      return null;
    }
  }

  /*  */
  async tokenRefreshAndUpdate() {
    const text = await this.tokenRefresh(this.tokenMeta.refresh_token);
    if (!text) return;

    this.tokenMetaSet(text);
  }
}
